/* Native details menu and native Shopify form: no dependency or submit interception. */
(()=>{'use strict';
 const menu=document.querySelector('.mobile-nav');
 if(menu){
  const trigger=menu.querySelector('summary');
  const sync=()=>{trigger.setAttribute('aria-expanded',String(menu.open));trigger.setAttribute('aria-label',menu.open?'Close menu':'Open menu');};
  menu.addEventListener('toggle',sync);sync();
  document.addEventListener('click',e=>{if(menu.open&&!menu.contains(e.target))menu.open=false;});
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&menu.open){e.preventDefault();menu.open=false;trigger.focus();}});
  document.addEventListener('focusin',e=>{if(menu.open&&!menu.contains(e.target))menu.open=false;});
  const wide=matchMedia('(min-width:1101px)');wide.addEventListener('change',e=>{if(e.matches)menu.open=false;});
 }
 const feedback=document.querySelector('[data-contact-feedback]');
 if(feedback){feedback.focus({preventScroll:true});feedback.scrollIntoView({block:'center',behavior:'instant'});}
})();
